/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: '大',
	['预设']: 'デフォルト',
	['较小']: '小',
	['字级大小']: 'フォントサイズ',
	['页面正在加载中']: 'ページが読み込まれています',
	['这可能需要几分钟的时间，请耐心等待']: '数分かかる場合がございます。しばらくお待ちください。',
	['您所访问的页面不存在']: 'お探しのページは見つかりませんでした',
	['开始对话']: 'チャットを開始',
	['充值未到帐快速通道']: '迅速チャージ未入金通路',
	['人工客服']: '人工カスタマーサポート',
	['已接听']: '接続済み',
	['结束对话']: 'チャットを終了',
	['联络人工客服']: 'オペレーターに連絡する',
	['重新选择智能客服']: 'スマートカスタマーサービスを再選択',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'ご利用ありがとうございました。今後の改善のため、アンケートにご協力をお願いいたします。',
	['您觉得此次的服务品质如何？']: '今回のサービスの質はいかがでしたか？',
	['颗星']: '星',
	['颗星(單數)']: '星',
	['不评分']: '評価しない',
	['点选下方即可结束对话']: '下のボタンをクリックすることで対話を終了できます。',
	['请输入您的ID']: 'IDを入力してください',
	['ID不能为空']: 'IDは必須項目です',
	['说明文字']: '説明文',
	['送出']: '送信',
	['系统维护中']: 'システムメンテナンス中',
	['储存']: '保存',
	['确认']: '確認',
	['取消']: 'キャンセル',
	['完成']: '完成',
	['协作']: '協力',
	['转接']: '転送',
	['离开']: '退出',
	['请选择服务对象开始通话']: 'サービス対象を選択して通話を開始してください',
	['请填写表单']: 'フォームに記入してください',
	['本对话已经结束']: 'この対話は終了しました',
	['客服已逾 {{second}} 秒未回应']: 'カスタマーサポートは{{second}}秒以上応答していません。',
	['历史对话']: '歴史対話',
	['查无资料']: '資料が見つかりません',
	['标签']: 'タグ',
	['正在输入中...']: '入力中...',
	['于']: 'に',
	['档案容量限制']: 'ファイル容量制限',
	['不能为空']: '空であってはいけません',
	['提交']: '送信',
	['满意度']: '満足度',
	['IP未知']: 'IP不明',
	['地区未知']: '地域未確認',
	['使用者环境未知']: 'ユーザー環境不明',
	['关闭']: '閉じる',
	['全萤幕截图成档案']: '全画面スクリーンショットをファイルに保存',
	['Mac用户']: 'Macユーザー',
	['Windows用户']: 'Windowsユーザー',
	['Windows键']: 'Windowsキー',
	['全萤幕截图至剪贴簿']: '全画面スクリーンショットをクリップボードにコピー',
	['截图完成后请直接于文字输入处贴上']: 'スクリーンショットが完了したら、直接テキスト入力欄に貼り付けてください。',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Windowsの内蔵スクリーンショットツールまたはQQソフトのスクリーンショット機能を使用して、スクリーンショットを完了したら、直接テキスト入力欄に貼り付けてください。',
	['截图']: 'スクリーンショット',
	['档案']: 'ファイル',
	['下载失败']: 'ダウンロードに失敗しました',
	['请输入分类名称']: '分類名を入力してください',
	['新增']: '追加',
	['更新']: '更新',
	['请选择一个分类']: 'カテゴリを選択してください',
	['请输入标题']: 'タイトルを入力してください',
	['请输入内文']: '内容を入力してください',
	['请上传图片']: '画像をアップロードしてください。',
	['快捷语']: 'ショートカット語',
	['图片']: '画像',
	['管理分类']: '管理カテゴリ',
	['新增分类']: '新しいカテゴリを追加',
	['标题/内文']: 'タイトル/本文',
	['分类']: '分類',
	['编辑']: '編集',
	['删除']: '削除',
	['平台名称']: 'プラットフォーム名',
	['显示']: '表示',
	['编辑服务平台']: '編集サービスプラットフォーム',
	['若有服务中的客户，无法关闭服务平台']: 'サービス中の顧客がいる場合、サービスプラットフォームを閉じることはできません。',
	['确定']: '確定',
	['人员列表']: '人員リスト',
	['服务人数']: 'サービス人数',
	['选择转接人员']: '転送担当者を選択',
	['按此上传图片']: '画像をアップロードするにはここをクリックしてください。',
	['确定要取消{{displayName}}协作邀请吗？']: '{{displayName}}との共同作業の招待をキャンセルしてもよろしいですか？',
	['确定要结束{{displayName}}的协作吗？']: '{{displayName}}の共同作業を終了してもよろしいですか？',
	['等待协作中']: '協力中',
	['协作中']: '協力中',
	['负责人']: '責任者',
	['已选择']: '選択済み',
	['可协作人数已满']: '協力できる人数が満員です',
	['选择协作人员']: '協力者の選択',
	['提示']: 'お知らせ',
	['请输入讯息']: 'メッセージを入力してください',
	['确定已經完成？']: '完了ですか？',
	['常用图片']: 'よく使う画像',
	['用户']: 'ユーザー',
	['个人']: '個人',
	['公共']: '公共',
	['开始谈话']: '会話を始める',
	['等待中']: '待機中',
	['客户已离开对话']: '顧客は会話を終了しました。',
	['正在转接给']: '転送中です。',
	['邀请你加入协作']: '協力に参加してもらえますか',
	['请求转接']: 'リクエスト転送',
	['正在服务中']: 'サービス中',
	['编辑平台']: '編集プラットフォーム',
	['您的连线已中断']: '接続が切断されました',
	['正尝试重新连线']: '再接続を試みています',
	['重新登入']: '再ログイン',
	['请先登入']: 'ログインしてください',
	['帐号']: 'アカウント',
	['帐号不能为空']: 'アカウントは空にできません',
	['请输入帐号']: 'アカウントを入力してください',
	['密码']: 'パスワード',
	['密码不能为空']: 'パスワードは空にできません',
	['请输入密码']: 'パスワードを入力してください',
	['登录']: 'ログイン',
	['客服系统客服端']: 'カスタマーサポートシステムクライアント',
	['平台异动，请重新整理']: 'プラットフォームの変更がありました。再度リフレッシュしてください。',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'カスタマーサービスシステムのアップグレードメンテナンス中ですので、後ほどオンラインカスタマーサービスにお問い合わせください。ありがとうございます。',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'カスタマーサポートシステムはアップグレードメンテナンス作業に入ります。ご対話を中断してしまい、申し訳ありませんが、後でオンラインカスタマーサポートにご連絡ください。',
	['请稍后再试']: 'しばらくしてからもう一度お試しください',
	['是']: 'です',
	['否']: 'いいえ',
	['等于']: '等しい',
	['包含']: '含む',
	['排除']: '排除',
	['大于']: '大きい',
	['少于']: '少ない',
	['数量区间']: '数量範囲',
	['客服对话数']: 'カスタマーサポートの対話数',
	['客戶对话数']: '顧客との対話数',
	['即时资讯']: '即時情報',
	['报表分析']: '報告分析',
	['平均通话时间']: '平均通話時間',
	['回覆通话数']: '通話の返信数',
	['平均等待时间']: '平均待機時間',
	['客户满意度']: '顧客満足度',
	['历史对话记录']: '歴史対話記録',
	['操作日志']: '操作ログ',
	['智能客服设定']: 'スマートカスタマーサポート設定',
	['机器人设定']: 'ロボット設定',
	['版本管理']: 'バージョン管理',
	['档案总览']: 'ファイル一覧',
	['设定']: '設定',
	['公司管理']: '会社管理',
	['维修管理']: 'メンテナンス管理',
	['一般设定']: '一般設定',
	['公告管理']: '公告管理',
	['帐号管理']: 'アカウント管理',
	['平台管理']: 'プラットフォーム管理',
	['角色管理']: 'キャラクター管理',
	['团队管理']: 'チーム管理',
	['标签管理']: 'タグ管理',
	['查询']: 'クエリ',
	['重置']: 'リセット',
	['今天']: '今日',
	['昨天']: '昨日',
	['过去7天']: '過去の7日間',
	['过去10天']: '過去10日',
	['过去一个月']: '過去一ヶ月',
	['过去90天']: '過去90日',
	['LOGO 预览']: 'LOGO プレビュー',
	['档案格式：PNG、JPG，长宽不超过']: 'ファイル形式：PNG、JPG、縦横のサイズは超えない',
	['档案太大或格式不支援']: 'ファイルが大きすぎるか、形式がサポートされていません',
	['且档案大小不得大于']: 'ファイルサイズは{0}を超えてはいけません。',
	['上传档案']: 'ファイルをアップロード',
	['新增IP白名单成功']: 'IPホワイトリストの追加に成功しました。',
	['删除IP白名单成功']: 'IPホワイトリストの削除が成功しました',
	['请输入欲查询的IP']: '入力したいIPを入力してください',
	['请输入IP']: 'IPを入力してください',
	['备注']: '備考',
	['备注不能为空']: '備考は空にできません',
	['请输入备注']: 'メモを入力してください',
	['新增时间']: '追加時間',
	['操作']: '操作',
	['IP白名单']: 'IPホワイトリスト',
	['新增IP']: '新しいIP',
	['新增IP白名单']: 'IPホワイトリストを追加',
	['确定删除此IP?']: 'このIPを削除してもよろしいですか？',
	['平台']: 'プラットフォーム',
	['团队']: 'チーム',
	['全体']: '全体',
	['客服']: 'カスタマーサービス',
	['客服系统']: 'カスタマーサポートシステム',
	['个人帐号设定']: '個人アカウント設定',
	['最少6码']: '最低6码',
	['最多20码']: '最大20ヤード',
	['不能有空白']: '空白はあってはいけない',
	['应至少包含1个英文和数字']: '英字と数字を少なくとも1つ含める必要があります。',
	['公司名称']: '会社名',
	['僅能输入英文和数字']: '英語と数字のみ入力できます',
	['应至少包含1个英文']: '少なくとも1つの英語を含む必要があります',
	['最少5码']: '最小5碼',
	['IP不能为空']: 'IPは空であってはいけません。',
	['非IP位址']: '非IPアドレス',
	['最多500个字']: '最大500字',
	['启用']: '有効化',
	['禁用']: '禁止',
	['对话量']: '対話量',
	['目前客户数']: '現在の顧客数',
	['目前客服数']: '現在のカスタマーサービスの数',
	['接通对话量']: '接続対話量',
	['全部']: '全部',
	['最近一天']: '最近一日',
	['最近一周']: '最近1週間',
	['最近一月']: '最近1ヶ月',
	['新增过滤器']: '新しいフィルターを追加',
	['请输入模組名称']: 'モジュール名を入力してください',
	['储存过滤模組']: 'ストレージフィルタモジュール',
	['读取过滤模組']: 'フィルターモジュールを読み取る',
	['确定要删除模組']: 'モジュールを削除してもよろしいですか？',
	['分钟']: '分単位',
	['接通时间']: '接通時間',
	['通话时间']: '通話時間',
	['请选择或输入时间']: '時間を選択または入力してください',
	['等待时间']: '待機時間',
	['对话搜寻']: '対話検索',
	['请输入对话']: '対話を入力してください',
	['客戶 ID']: '顧客 ID',
	['请输入客戶ID']: '顧客IDを入力してください',
	['对话浏览模式']: '対話ブラウジングモード',
	['筆']: '筆記用具',
	['客服本名']: 'カスタマーサポート本名',
	['进入时间']: '入場時間',
	['客服昵称']: 'カスタマーサポートのニックネーム',
	['客服系统管理端']: 'カスタマーサポートシステム管理端',
	['数量']: '数量',
	['尚未上传档案']: 'ファイルはまだアップロードされていません',
	['输入文字']: '入力文字',
	['请在此输入文字']: 'ここに文字を入力してください',
	['添加项目']: '項目を追加',
	['请选择']: '選んでください',
	['新增文字']: 'テキストを追加',
	['新增档案']: '新しいファイル',
	['選項']: 'オプション',
	['勾选标题']: 'タイトルをチェックする',
	['文字內容不能为空']: '文字内容は空にできません',
	['添加']: '追加',
	['上传标题']: 'アップロードタイトル',
	['单选标题']: '単一選択タイトル',
	['输入框标题']: '入力ボックスのタイトル',
	['请输入']: '入力してください',
	['输入框']: '入力ボックス',
	['单选']: '単一選択',
	['核取方块']: 'チェックボックス',
	['请选择一个标签']: 'ラベルを選択してください',
	['确定要删除此项目和其所有子项目？']: 'このアイテムとそのすべてのサブアイテムを削除してもよろしいですか？',
	['答案']: '答え',
	['表单']: 'フォーム',
	['清除此阶层设定']: 'この階層設定をクリアする',
	['请输入此阶层问题']: 'この階層の問題を入力してください',
	['新增选项']: 'オプションを追加',
	['新增表单']: '新しいフォーム',
	['新增答案']: '回答を追加',
	['新增充值表单']: '新しいチャージフォーム',
	['若切换种类后, 将清除原有的和其子项目资料']: '種類を切り替えると、元のデータおよびその子項目の資料がクリアされます。',
	['确定要清除所有资料和其子项目资料？']: 'すべてのデータとそのサブプロジェクトのデータを削除してもよろしいですか？',
	['阶层']: '階層',
	['开场语']: 'オープニングスピーチ',
	['开场语不能为空']: 'オープニングメッセージは空にできません',
	['结尾感谢语']: '結びの言葉',
	['结尾感谢语不能为空']: '結尾感謝の言葉は空白にできません',
	['发布']: '公開',
	['复制']: 'コピー',
	['选择目的平台']: '目的のプラットフォームを選択してください',
	['确定复制到']: 'コピーすることを確定する',
	['是否要正式发布到使用环境？']: '使用環境に正式にリリースしますか？',
	['储存版本']: '保存版',
	['版本名称']: 'バージョン名',
	['请输入版本名称']: 'バージョン名を入力してください',
	['确定是否储存此版本']: 'このバージョンを保存するかどうか確認しますか',
	['版本储存成功']: 'バージョンの保存に成功しました',
	['最多10个字']: '最大10文字',
	['公告一']: 'お知らせ1',
	['公告二']: 'お知らせ二',
	['公告三']: '公告三的日本語是「告知三」。',
	['公告储存成功']: '公告の保存が成功しました',
	['标题']: 'タイトル',
	['內文']: '内容',
	['修改登入密码']: 'ログインパスワードを変更する',
	['修改基本资讯']: '基本情報の修正',
	['昵称']: 'ニックネーム',
	['昵称不能为空']: 'ニックネームは空白にできません',
	['请输入昵称']: 'ニックネームを入力してください',
	['本名']: '本名',
	['本名不能为空']: '本名は空にできません',
	['请输入本名']: '本名を入力してください',
	['选择图像']: '画像を選択する',
	['状态']: '状態',
	['平台代码']: 'プラットフォームコード',
	['平台代码不能为空']: 'プラットフォームコードは空であってはいけません',
	['使用ID模式登入']: 'IDモードでログイン',
	['新增平台']: '新しいプラットフォーム',
	['修改平台']: '修正プラットフォーム',
	['确定重新产生Key/IV?']: 'キー/IVを再生成しますか？',
	['进入公司成功']: '会社に入る成功',
	['确定禁用公司?']: '会社を無効にすることを確認しますか？',
	['确定启用公司?']: '会社を有効にしますか？',
	['修改公司']: '会社の変更',
	['进入公司']: '会社に入る',
	['确定进入公司?']: '会社に入ることを決定しましたか？',
	['新增标签']: 'タグを追加',
	['代号']: 'コード',
	['代号不可为空']: 'コードは空にできません',
	['名称']: '名称',
	['名称不可为空']: '名称は空にできません。',
	['颜色']: '色彩',
	['颜色不可为空']: '色は空であってはいけません',
	['进入标签']: 'タグに入る',
	['修改标签']: 'タグを修正する',
	['确定开启进入标签?']: 'タブを開くことを確認しますか？',
	['确定关闭进入标签?']: 'タブを閉じてよろしいですか？',
	['确定删除此标签?']: 'このタグを削除してもよろしいですか？',
	['标签创建成功']: 'タグ作成成功',
	['标签更新成功']: 'タグの更新が成功しました',
	['进入标签更新成功']: 'タグの更新が成功しました',
	['标签删除成功']: 'タグの削除に成功しました',
	['请输入代号、名称等关键字']: 'コード、名称などのキーワードを入力してください。',
	['设定开场白成功']: 'オープニングセリフの設定が成功しました',
	['客戶进入开场白']: '顧客のオープニングトーク',
	['客戶进入开场白不可为空']: '顧客のオープニングは空にしてはいけません。',
	['第一次通知时间']: '初回通知時間',
	['第{{count}}次通知时间']: '第{{count}}回の通知時間',
	['设置错误']: '設定エラー',
	['设定等待过长通知时间成功']: '設定待機時間が長すぎる通知に成功',
	['秒']: '秒',
	['对话自动断开时间']: '対話自動切断時間',
	['未发话时间']: '未発話時間',
	['未发话提示文字']: '未発話ヒントテキスト',
	['设定对话断开成功']: '対話の切断が成功しました',
	['Favicon预览']: 'Faviconのプレビュー',
	['更换 Favicon 成功']: 'Faviconの変更に成功しました',
	['档案格式：ICO，長寬不超過 32x32 px']: 'ファイル形式：ICO，サイズは32x32pxを超えないこと。',
	['更换 LOGO 成功']: 'LOGOの変更が成功しました',
	['智能客服']: 'スマートカスタマーサービス',
	['设定通道成功']: 'チャネルの設定に成功しました',
	['设定提示音效成功']: '効果音の設定が成功しました',
	['单音']: '単音',
	['循环音']: 'ループ音',
	['编号']: '番号',
	['资料类型']: '資料タイプ',
	['资料类型不可为空']: '資料のタイプは空白にできません。',
	['数字']: '数字',
	['字串']: '文字列',
	['布林']: 'ブリン',
	['建立标签成功']: 'タグの作成に成功しました',
	['修改标签成功']: 'タグの変更に成功しました',
	['删除标签成功']: 'タグの削除に成功しました',
	['更换 LOGO']: 'ロゴを変更する',
	['更换 Favicon']: 'ファビコンを変更する',
	['对话断开']: '対話が切断されました',
	['等待过长通知时间']: '待ち時間が長すぎる通知',
	['开场白']: 'オープニング',
	['提示音效设定']: '通知音效設定',
	['通道设定']: '通路設定',
	['自定义标签']: 'カスタムタグ',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: '修理モードをオンにすると、カスタマーサービスシステムの運用が停止します。オンにしてもよろしいですか？',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'メンテナンスモードを終了します。カスタマーサービスシステムは引き続き運営されます。終了しますか？',
	['状态更新成功']: '状態更新成功',
	['通知讯息更新成功']: '通知メッセージの更新が成功しました',
	['维修模式']: 'メンテナンスモード',
	['通知讯息设定']: '通知メッセージ設定',
	['尚未连线状态']: '接続されていない状態',
	['尚未连线状态描述']: '接続未完了状態説明',
	['已连线状态']: '接続済み状態',
	['已连线状态描述']: '接続状態の説明',
	['开启成功']: '起動成功',
	['关闭成功']: '成功に閉じる',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'ログイン管理モードを閉じると、顧客がIDを入力してカスタマーサービスに入ることが制限されます。本当に閉じますか？（顧客のプロフィール情報が提供されていない場合は、エラーページに入ります）',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'ログイン管理モードを開くと、顧客はIDを入力してカスタマーサービスに入ることができます。開いてもよろしいですか？',
	['请输入帐号、昵称、角色等关键字']: 'アカウント、ニックネーム、キャラクターなどのキーワードを入力してください。',
	['新增角色']: 'キャラクター追加',
	['修改角色']: 'キャラクターを変更する',
	['角色创建成功']: 'キャラクター作成成功',
	['角色更新成功']: 'キャラクターの更新が成功しました',
	['角色删除成功']: 'キャラクターの削除が成功しました',
	['请输入角色名称，平台，权限等关键字']: 'キャラクター名、プラットフォーム、権限などのキーワードを入力してください',
	['关键字']: 'キーワード',
	['角色名称']: 'キャラクター名',
	['角色名称不可为空']: 'キャラクター名は空白にできません。',
	['请输入角色名称']: 'キャラクター名を入力してください',
	['上级角色']: '上司角色',
	['上级角色不可为空']: '上位の役割は空にできません',
	['权限']: '権限',
	['确定删除此角色?']: 'このキャラクターを削除してもよろしいですか？',
	['图像不能为空']: '画像は空であってはいけません',
	['新增团队']: 'チームを追加',
	['修改团队']: '修正チーム',
	['团队创建成功']: 'チームの作成が成功しました',
	['团队修改成功']: 'チームの修正が成功しました',
	['团队删除成功']: 'チームの削除に成功しました',
	['人数']: '人数',
	['新登入密码']: '新しいログインパスワード',
	['新密码不能设定與舊密码相同']: '新しいパスワードは古いパスワードと同じに設定できません。',
	['新密码與確認密码不相同']: '新しいパスワードと確認用パスワードが一致しません',
	['确定修改登入密码?']: 'ログインパスワードを変更してもよろしいですか？',
	['登入密码修改成功，请重新登入']: 'ログインパスワードの変更が成功しました。再度ログインしてください。',
	['个人资讯']: '個人情報',
	['搜寻快捷语']: '検索ショートカット',
	['登出']: 'ログアウト',
	['帐密错误']: 'アカウントのパスワードが間違っています',
	['一']: '1つ',
	['二']: '2つ',
	['三']: '3つ',
	['四']: '4つ',
	['五']: '5つ',
	['六']: '6つ',
	['七']: '7つ',
	['请输入客服本名、客服昵称等关键字']: 'カスタマーサポートの本名、カスタマーサポートのニックネームなどのキーワードを入力してください。',
	['共 {{count}} 筆资料']: '共 {{count}} 件のデータ',
	['平台语言不能为空']: 'プラットフォーム言語は空にできません',
	['开启']: '開始',
	['语言']: '言語',
	['切换语言']: '言語を切り替える',
	['语言名称']: '言語名',
	['系统设定']: 'システム設定',
	['储存成功']: '保存成功',
	['发布成功']: '公開成功',
	['复制成功']: 'コピー成功',
	['项目选取']: 'プロジェクト選定',
	['图像']: '画像',
	['角色']: 'キャラクター',
	['新增帐号']: 'アカウントを追加',
	['角色不能为空']: '役割は空であってはいけません',
	['登入密码']: 'ログインパスワード',
	['请输入代号、名称、备注等关键字']: 'コード、名称、備考などのキーワードを入力してください',
	['确定删除此团队?']: 'このチームを削除してもよろしいですか？',
	['切换语言成功']: '言語の切り替えに成功しました',
	['确定要切换语言?']: '言語を切り替えますか？',
	['选项']: 'オプション',
	['选择语言']: '言語を選択する',
	['修改成功']: '変更成功',
	['舊登入密码']: '旧ログインパスワード',
	['確認新登入密码']: '新しいログインパスワードを確認する',
	['语言切换成功，將重整页面以套用更新']: '言語切り替え成功、ページを更新して適用します。',
	['笔 / 页']: '筆 / ページ',
	['时段搜寻']: '時間帯検索',
	['请选择时段']: '時間帯を選んでください',
	['更换背景色']: '背景色を変更する',
	['设定背景颜色成功']: '背景色の設定に成功しました',
	['请重新登入']: '再ログインしてください',
	['绑定谷歌验证']: 'Google認証をバインドする',
	['解除绑定']: '解除バインド',
	['谷歌验证状态']: 'Googleの検証ステータス',
	['已绑定']: 'バインド済み',
	['未绑定']: '未バインド',
	['解绑谷歌验证失败']: 'Google認証の解除に失敗しました',
	['二维码方式添加']: 'QRコードで追加',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Google 認証システムにバーコード追加方式で追加してください。',
	['密钥方式添加']: '鍵方式追加',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Google 認証システムで提供されたキーを入力して追加してください。',
	['密钥如下所示']: '鍵は以下の通りです',
	['请再次输入登入密码']: '再度ログインパスワードを入力してください',
	['谷歌6位动态密码']: 'Google 6桁の動的パスワード',
	['请绑定谷歌验证']: 'Google 認証をバインドしてください。',
	['谷歌验证绑定成功']: 'Google認証のバインド成功',
	['解绑谷歌验证成功']: 'Google認証の解除に成功しました',
	['确定解绑谷歌验证？']: 'Google認証を解除してもよろしいですか？',
	['请输入谷歌动态码']: 'Googleの動的コードを入力してください',
	['谷歌动态码']: 'Google Authenticator',
	['谷歌动态码不能为空']: 'Googleのダイナミックコードは空欄にできません',
	['谷歌动态码长度6码']: 'Googleの動的コードの長さは6桁です。',
	['谷歌动态码错误']: 'Googleの動的コードエラー',
	['內容']: '内容',
	['搜寻']: '検索',
	['连线中断，点击“确定”即重新连线客服。']: '接続が切断されました。「OK」をクリックすると再びカスタマーサービスに接続します。',
	['充值表单']: 'チャージフォーム',
	['网银充值']: 'ネットバンキング入金',
	['扫码充值']: 'QRコード入金',
	['带入目前帐号']: '現在のアカウントを引き込みます',
	['自行输入平台帐号']: '自分でプラットフォームアカウントを入力してください',
	['充值方式']: '入金方法',
	['平台帐号']: 'プラットフォームアカウント',
	['充值金额']: '入金金額',
	['付款人姓名']: 'お支払い名義',
	['确认语']: '確認語',
	['操作时间']: '操作時間',
	['操作者']: '操作者の翻訳は「オペレーター」です。',
	['请输入备注等关键字']: '備考などのキーワードを入力してください',
	['操作类型']: '操作タイプ',
	['修改平台昵称']: 'プラットフォームのニックネームを変更する',
	['修改平台昵称成功']: 'プラットフォームのニックネームの変更が成功しました',
	['输入格式错误']: '入力フォーマットエラー',
	['套用']: '適用',
	['确定套用到']: '適用する',
	['套用成功']: '適用成功',
	['储存方式']: '保存方法',
	['储存時間']: '保存時間',
	['系统发布']: 'システムリリース',
	['手动储存']: '手動保存',
	['自动储存']: '自動保存',
	['预览']: 'プレビュー',
	['最多350个字']: '最大350文字',
	['修改']: '修正',
	['共同资讯管理']: '共同情報管理',
	['共同资讯创建成功']: '共同ニュースの作成が成功しました',
	['共同资讯修改成功']: '共同情報の修正が成功しました',
	['新增共同资讯']: '共同情報を追加',
	['修改共同资讯']: '共同情報を修正する',
	['删除成功']: '削除成功',
	['已设置于其他答案，无法删除']: '他の回答に設定されているため、削除できません。',
	['请输入名称、内容等关键字']: '名前、内容などのキーワードを入力してください',
	['确定删除此共同资讯？']: 'この共同情報を削除してもよろしいですか？',
	['共同资讯']: '共同通信',
	['尚未选择共同资讯']: 'まだ共同情報が選択されていません',
	['选择共同资讯']: '共同情報を選択する',
	['选择']: '選ぶ',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '「確定」をクリックすると、そのプラットフォームのショートカット設定が上書きされます。',
	['已复制：目的平台']: '目的プラットフォーム',
	['是否离开客服系统？']: 'カスタマーサポートシステムを離れますか？',
	['感谢您的作答，此次评分为：{{score}}分']: 'ご回答いただきありがとうございます。今回の評価は：{{score}}点です。',
	['共 {{count}} 筆']: '共 {{count}} 件',
	['分']: '分',
	['新增公司']: '新しい会社',
	['翻译']: '翻訳',
	['显示原文']: '原文を表示する',
	['解绑谷歌验证']: 'グーグル認証を解除する',
	['请输入名称 内容等关键字']: '名前や内容などのキーワードを入力してください',
	['表单选项']: 'フォームのオプション',
	['年']: '年齢',
	['等待时间颜色设定']: '待機時間の色設定',
	['显示颜色']: '色を表示する',
	['确认删除此规则?']: 'このルールを削除してもよろしいですか？',
	['页签']: 'タブ',
	['超过 {{time}} 分钟']: '{{time}} 分以上',
	['新增成功']: '追加成功',
	['删除完成']: '削除完了',
	['等待时间(分钟)']: '待機時間（分）',
	['时间']: '時間',
	['不可为空']: '空白にできません',
	['需为正整数']: '正の整数である必要があります',
	['按平台名称排列(A-Z)']: 'プラットフォーム名で並べる(A-Z)',
	['按平台名称排列(Z-A)']: 'プラットフォーム名で並べ替え (Z-A)',
	['旧版面模式']: '旧版面モード',
	['自动翻译']: '自動翻訳',
	['功能設定']: '機能設定',
	['确认切换版面？']: '切り替え画面を確認しますか？',
	['确认开启自动翻译？']: '自動翻訳をオンにしますか？',
	['确认关闭自动翻译？']: '自動翻訳を終了しますか？',
	['原文']: '原文',
	['泰语']: 'タイ語',
	['追踪']: '追跡',
	['取消追踪']: 'フォロー解除',
	['预览影片']: '動画をプレビューする',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'MP4、MOV、JPEG (JPG)、PNG、GIF、HEIC、RAW、HEIFファイルのみアップロードできます。',
	['请勿输入语法相关字串']: 'プログラムコードや特殊文字を入力しないでください',
	['输入名称']: '入力名',
	['设为预设版本']: 'デフォルトバージョンに設定する',
	['另存为新版本']: '新しいバージョンとして保存',
	['请选择版本']: 'バージョンを選択してください',
	['一键开关']: 'ワンタッチスイッチ',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'サービス中の顧客がいる場合、サービスプラットフォームを閉じることやバージョンを切り替えることはできません。',
	['是否确认要覆盖已有的设定，储存新的设定？']: '既存の設定を上書きして、新しい設定を保存しますか？',
	['已储存超过五个版本']: '5つ以上のバージョンが保存されました',
	['版本已变动，是否需要储存？']: 'バージョンが変更されました。保存しますか？',
	['确定删除此版本？']: 'このバージョンを削除してもよろしいですか？',
	['编辑版本']: '編集版',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'カスタマーサポートシステムに重複して連絡していることが検出されました。本人以外の場合は、カスタマーサポートにお知らせください。',
	['删除此版本']: 'このバージョンを削除',
	['刪除成功']: '削除成功',
	['刪除失敗']: '削除失敗',
	['儲存成功']: '保存成功',
	['儲存失敗']: '保存失敗',
	['您好，请问要选择哪个问题？']: 'どの内容についてお問合せでしょうか？',
	['等待服务区']: '待機サービスエリア',
	['按时间排列(長到短)']: '時間順に並べる(長いものから短いものへ)',
	['按时间排列(短到長)']: '時間順に並べる',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'ようこそ！すぐにご対応いたしますので、少々お待ちください...',
	['编辑标签']: '編集ラベル',
	['于 {{time}} 侦测到会员【稍早已离线】']: '{{time}} にメンバー【先ほどオフライン】が検出されました。',
	['{{score}}分']: '{{score}}点',
	['未评分']: '未評価',
	['客服完成']: 'カスタマーサービス完了',
	['会员离线']: '会員オフライン',
	['超时自动断线']: 'タイムアウト自動切断',
	['{{text}}不可重复']: '{{text}}は繰り返せません',
	['{{text}}不能为空']: '{{text}}は空であってはいけません',
	['{{text}}设置错误']: '{{text}}の設定エラー',
	['平均通话时长']: '平均通話時間',
	['平均通话数']: '平均通話数',
	['请选择角色名称']: 'キャラクター名を選択してください',
	['请选择客服']: 'カスタマーサポートを選択してください',
	['请选择团队']: 'チームを選択してください',
	['播放']: '再生',
	['统计时间']: '統計時間',
	['统计时间不可为空']: '統計時間は空にできません',
	['请输入时间']: '時間を入力してください',
	['时间筛选']: '時間フィルター',
	['汇出']: '輸出',
	['未出勤']: '未出勤',
	['客服平均通话时长']: 'カスタマーサービスの平均通話時間',
	['数量筛选']: '数量フィルタ',
	['客服平均等待时间']: 'カスタマーサービスの平均待機時間',
	['上一个月']: '先月',
	['导出Excel成功']: 'Excelのエクスポートに成功しました',
	['对话结束']: 'チャット終了',
	['满意度/客服']: '満足度/カスタマーサポート',
	['日期/客服']: '日付/カスタマーサービス',
	['总数']: '合計',
	['日平均']: '日平均',
	['客服日均量']: 'カスタマーサービス日平均量',
	['客服通话总量']: 'カスタマーサポート通話総量',
	['日总量']: '日総量',
	['请输入数量']: '数量を入力してください',
	['满意度预设分数']: '満足度予想スコア',
	['当会员未评分，会自动给予此预设分数。']: '会員が未評価の場合、この設定のスコアを自動的に与えられます。',
	['设定满意度预设分数成功']: '満足度のプリセットスコアの設定に成功しました',
	['客户满意度管理']: '顧客満足度管理',
	['对话结束方式']: '対話終了方法',
	['对话满意度']: '対話満足度',
	['时段']: '時間帯',
	['客服平均满意度']: 'カスタマーサービスの平均満足度',
	['公用设定']: '公開設定',
	['通话时长']: '通話時間',
	['服务时段']: 'サービス時間',
	['储存时间']: '保存時間',
	['客服不可为空']: 'カスタマーサービスは空であってはいけません',
	['团队不可为空']: 'チームは空であってはいけません',
	['请输入对话内容关键字']: '対話内容のキーワードを入力してください',
	['请输入客服本名、昵称或帐号']: 'カスタマーサービスの本名、ニックネーム、またはアカウントを入力してください。',
	['平台不可为空']: 'プラットフォームは空にできません',
	['线上']: 'オンライン',
	['离线']: 'オフライン',
	['日期不可为空']: '日付は空にできません。',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: '親愛なる方、再度確認させていただきますが、この金額 {{chargeNumber}} 元の入金を申し込み、行うアカウントは {{chargeAccount}} でよろしいでしょうか？',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'あなたの待機順位は {{pendingOrder}} 位です',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '{{inviter}} から {{invitee}} への転送を拒否します。',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}} は {{time}} にウィンドウを閉じました',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}} は {{time}} に案件を完了しました。',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}} は {{time}} にコラボレーションに成功裏に参加しました。',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}} は {{time}} にコラボレーションを離れました',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}} は {{time}} に接続を中断しました',
	['英文']: '英語',
	['验证码设定']: '認証コード設定',
	['启用验证码']: 'キャプチャを有効にする',
	['设定验证码成功']: '設定した確認コードは成功しました',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: '验证码機能を有効にした後、顧客は認証を完了する必要があります。',
	['禁止连续发话']: 'メッセージの連続送信はお控えください。',
	['启用禁止连续发话']: '連続発話を禁止するを有効にする',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: '会員が「制限秒数」内に設定された回数を超えて発言すると、システムが自動的に警告を表示します。',
	['客户端限制于']: 'クライアント制限付き',
	['发话次数达到']: '発言回数が達する',
	['次']: '次',
	['暂时无法发话']: '一時的に話せません',
	['储存完成']: '保存完了',
	['发送消息过于频繁 可稍后再试']: 'メッセージの送信が頻繁すぎます。後でもう一度お試しください。',
	['IP黑名单管理']: 'IPブラックリスト管理',
	['共 {{total}} 笔']: '合計 {{total}} 件',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '第 {{min}} - {{max}} 件/共 {{total}} 件',
	['顯示']: '表示',
	['查询IP黑名单']: 'IPブラックリストの確認',
	['设定自动添加黑名单']: '自動でブラックリストに追加する設定',
	['白名單管理']: 'ホワイトリスト管理',
	['解除时间']: '解除時間',
	['永久封锁']: '永久封鎖',
	['新增IP黑名单']: 'IPブラックリストを追加',
	['加入黑名单后，该IP将无法进入客服前台。']: 'ブラックリストに追加された後、そのIPはカスタマーサポートのフロントにアクセスできなくなります。',
	['请完成安全验证']: 'セキュリティ認証を完了してください',
	['向右滑动填充拼图']: 'パズルピースを右へスライド',
	['启用功能']: '機能を有効にする',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'IPが「制限時間」内に設定された「ログイン回数」を超えてログインすると、システムは自動的にブラックリストに追加されます。',
	['限制时间']: '制限時間',
	['时间单位不可为空']: '時間単位は空にできません',
	['时间单位']: '時間の単位',
	['登入次数']: 'ログイン回数',
	['封锁时间']: '封鎖時間',
	['锁的持续时间，时间到了会自动解除']: 'ロックの持続時間。時間が来ると自動的に解除されます。',
	['查询IP白名单']: 'IPホワイトリストをクエリする',
	['删除失败']: '削除に失敗しました',
	['修改失败']: '変更失敗',
	['拼图验证失败次数过多']: 'パズル認証の試行回数が上限を超えました',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}} は {{time}} に協力への参加を拒否しました。',
	['储存过滤模組成功']: '保存フィルターモジュールの成功',
	['删除过滤模組成功']: 'フィルターモジュールの削除に成功しました',
	['解除谷歌验证成功']: 'Google認証の解除に成功しました。',
	['确定禁用平台?']: 'プラットフォームを無効にしますか？',
	['确定启用平台?']: 'プラットフォームを有効にしますか？',
	['IP管理(客户端)']: 'IP管理（クライアント）',
	['上传']: 'アップロード',
	['此栏位的时间会使用于报表的团队筛选']: 'この欄位の時間はレポートのチームフィルタリングに使用されます。',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'チームを選択：そのチームのすべてのカスタマーサポートスタッフのデータをチーム統計期間中にフィルタリングします。',
	['备注最多{{inputLimit}}个字']: '最大{{inputLimit}}文字を備考してください。',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}} は {{time}} に {{from}} から {{invitee}} に対話を転送しました。',
	['小时']: '時間',
	['日']: '日曜日',
	['会员IP：{{ip}} 已加入前台黑名单']: '会員IP：{{ip}} がフロントエンドのブラックリストに追加されました。',
	['新增失败']: '追加に失敗しました',
	['会员IP被加入黑名单']: '会員IPがブラックリストに追加されました',
	['登入/接待时间']: 'ログイン/受付時間',
	['timePeriodTooltipMessage']: '時間帯ツールチップメッセージ',
	['平均接待时间']: '平均対応時間',
	['平均登入时间']: '平均ログイン時間',
	['接待时间报表']: '受付時間報告',
	['登入时间报表']: 'ログイン時間レポート',
	['未登入']: '未ログイン',
	['设定报表']: 'レポート設定',
	['设定对话是否记入报表中']: '対話をレポートに記録するかどうかを設定する',
	['平均通话时长报表']: '平均通話時間報告',
	['平均通话数报表']: '平均通話数報告',
	['平均等待时间报表']: '平均待機時間報告',
	['客户满意度报表']: '顧客満足度報告書',
	['平均回覆时间报表']: '平均返信時間レポート',
	['调整原因']: '調整理由',
	['请输入调整原因']: '調整理由を入力してください',
	['调整原因不可为空']: '調整理由は空にすることはできません。',
	['日期时间']: '日時',
	['操作人']: 'オペレーター',
	['原因']: '理由',
	['更多']: 'もっと',
	['收回']: '取り戻す',
	['设定报表成功']: 'レポートの設定が成功しました',
	['平均回覆时间']: '平均返信時間',
	['客服平均回覆时间']: 'カスタマーサポートの平均返信時間',
	['客户回头率']: '顧客リピート率',
	['客户ID']: '顧客ID',
	['客服帐号']: 'カスタマーサービスアカウント',
	['小时回头率']: '時間帯の回頭率',
	['日回头率']: 'リピート率',
	['遗漏时间']: '遅延時間',
	['请选择遗漏时间']: '欠落時間を選択してください',
	['平均遗漏时间']: '平均欠損時間',
	['1分钟']: '1分',
	['2分钟']: '2分',
	['3分钟']: '3分',
	['4分钟']: '4分',
	['5分钟']: '5分',
	['离开时间']: '出発時刻',
	['客户回头率报表']: '顧客リピート率報告書',
	['平台报表']: 'プラットフォームレポート',
	['对话总量']: '対話総量',
	['接待总量']: '接待総量',
	['遗漏总量']: '漏れ総量',
	['智能客服总量']: 'インテリジェントカスタマーサービス総量',
	['智能转客服总量']: 'スマート転送カスタマーサービスの総量',
	['最后更新时间']: '最終更新日時',
	['客服人数']: 'カスタマーサポート人数',
	['在线客服总数']: 'オンラインカスタマーサービスの総数',
	['等待服务']: 'サービスを待つ',
	['正在服务']: 'サービス中',
	['智能未转客服总量']: 'スマート未転送カスタマーサービス総量',
	['使用平台']: '使用プラットフォーム',
	['泰文名称']: 'タイ語の名称',
	['请输入泰文名称']: 'タイ語の名前を入力してください',
	['英文名称']: '英語名',
	['请输入英文名称']: '英語名を入力してください',
	['中文名称']: '中文名',
	['请输入中文名称']: '中国語の名前を入力してください',
	['若无需翻译请填写中文']: '翻訳が不要な場合は中国語を記入してください。',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'アカウントの全ての報告データはアカウントと共に削除されますが、削除してもよろしいですか？',
	['停用']: '停止',
	['停用帐号']: 'アカウント停止',
	['通话总数']: '通話総数',
	['等待中人数：{{pendingConversationCount}} 人']: '待機中の人数：{{pendingConversationCount}} 人',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'レポートはエクスポート中です。「レポートダウンロード」ページに移動して進捗を確認し、ダウンロードしてください。',
	['汇出Load Data']: 'データをエクスポート',
	['报表下载']: 'レポートダウンロード',
	['全平台']: '全プラットフォーム',
	['报表类型']: '報告タイプ',
	['数据范围']: 'データ範囲',
	['汇出时间']: 'エクスポート時間',
	['完成时间']: '完成時間',
	['申请者']: '応募者',
	['下载']: 'ダウンロード',
	['重新汇出']: '再発送',
	['处理中']: '処理中',
	['已完成']: '完了',
	['失败']: '失敗',
	['下载成功']: 'ダウンロード成功',
	['历史对话纪录']: '歴史対話記録',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: '接続が切断されました。確認をクリックして接続の回復を試みてください。回復できない場合は、対話を終了します。',
	['引用功能管理']: '引用機能管理',
	['引用对话']: '引用対話',
	['设定引用对话成功']: '引用対話の設定が成功しました',
	['客户管理']: '顧客管理',
	['重要客户帐号']: '重要顧客アカウント',
	['请输入重要客户帐号、备注等关键字']: '重要な顧客のアカウント、備考などのキーワードを入力してください',
	['新增重要客户']: '重要顧客を追加',
	['重要客户帐号不能为空']: '重要な顧客アカウントは空にできません',
	['输入多个帐号请用, 区隔']: '複数のアカウントを入力する場合は、, で区切ってください。',
	['修改重要客户']: '重要な顧客を修正する',
	['重要帐号']: '重要なアカウント',
	['会员类型']: '会員タイプ',
	['引用']: '引用',
	['收回(訊息)']: 'メッセージを撤回する',
	['收回功能管理']: '機能管理の回収',
	['收回提示文字不能为空']: '収回提示文字は空にできません。',
	['收回对话']: '対話を取り消す',
	['收回提示文字（中文）']: '提示文字を回収する',
	['收回提示文字（英文）']: 'ヒントテキストを取り消す（英語）',
	['收回提示文字（泰文）']: 'ヒントテキストを回収する',
	['视频']: '動画',
	['确定要收回讯息吗？']: 'メッセージを取り消してもよろしいですか？',
	['设定收回功能成功']: '設定収回機能成功',
	['遗漏数据']: 'データの欠落',
	['全选']: '全選',
	['请选择使用平台']: 'プラットフォームを選択してください',
	['日期计算方式']: '日付の計算方法',
	['以会员进入正在服务区的时间计算']: '会員がサービスエリアに入った時間で計算する',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: '会員が待機サービスエリアに入る時間を基準に計算し、もしスマートカスタマーサービスをクリックして待機サービスエリアに入らなかった場合は、スマートカスタマーサービスに入った時間を基準に計算します。',
	['以会员进入等待服务区的时间计算']: '会員がサービスエリアに入るまでの待機時間を計算する',
	['以客服接通对话的时间进行计算']: 'カスタマーサービスの通話時間で計算する',
	['以会员进入等待服务区的时间进行计算']: '会員がサービス待機エリアに入る時間を基に計算する',
	['以会员点击智能客服的时间计算']: '会員がスマートカスタマーサービスをクリックした時間で計算する',
	['相同类型才会计算回头']: '同じタイプだけが振り返りを計算します。',
	['登入联系离开后再次登入联系']: 'ログイン連絡離脱後再度ログイン連絡',
	['一通对话只会触发一次回头次数']: '一度の対話では振り返り回数は一度だけ発生します。',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: '同じ会員期間内に連続して3回連絡した場合、最初の2回の対話のカスタマーサービスをそれぞれ1回カウントします。',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: '毎日同じ会員が対話終了後{{hour}}時間以内に再度連絡する有効対話比率',
	['未登入联系离开后再次未登入联系']: '未ログインのまま連絡を離れた後、再び未ログインのまま連絡',
	['请输入重要客户帐号']: '重要な顧客アカウントを入力してください',
	['开始日期']: '開始日',
	['结束日期']: '終了日',
	['标签名称/数量']: 'タグ名/数量',
	['暂无数据']: 'データなし',
	['AI客服设定']: 'AIカスタマーサービス設定',
	['AI共同设定']: 'AI共同設定',
	['平台AI设定']: 'プラットフォームAI設定',
	['平台 AI SKILL 设定']: 'プラットフォーム AI SKILL 設定',
	['指令输入说明']: '指令入力説明',
	['输入文字档']: '入力テキストファイル',
	['不需要区分功能']: '機能を区別する必要はない',
	['套用平台']: 'プラットフォームを適用する',
	['请输入指令']: 'コマンドを入力してください',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AIと会員との対話が<<inputNumber>>回を超えた場合、カスタマーサポートに通知する必要があります。',
	['指令']: '指令',
	['AI开关']: 'AIスイッチ',
	['AI客服名称']: 'AIカスタマーサービス名',
	['AI客服名称不能为空']: 'AIカスタマーサービス名は空欄にできません。',
	['请输入AI客服名称']: 'AIカスタマーサービス名を入力してください',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'AIカスタマーサービスを終了しますか？終了すると、再度AIカスタマーサービスを開始することはできません。',
	['侦测到对话有异常状态，请尽快处理']: '対話に異常な状態が検出されましたので、早急に対処してください。',
	['需要转接人工客服，请尽快处理']: 'オペレーターに転送する必要がありますので、できるだけ早く処理してください。',
	['总平均通话时长']: '総平均通話時間',
	['AI平均通话时长']: 'AIの平均通話時間',
	['人工平均通话时长']: '人工平均通話時間',
	['每日总平均']: '毎日の総平均',
	['AI日平均']: 'AI日平均',
	['人工日平均']: '人工日平均は「人工日平均」と言います。',
	['通话总量']: '通話の総量',
	['AI通话总量']: 'AI通話総量',
	['共同']: '共同',
	['总计']: '合計',
	['总计请勿超过{{limit}}字']: '合計は{{limit}}字を超えないでください',
	['总平均回覆时间']: '総平均返信時間',
	['AI平均回覆时间']: 'AIの平均返信時間',
	['人工平均回覆时间']: '人工平均返信時間',
	['AI日总量']: 'AI日の総量',
	['人工日总量']: '人工日総量',
	['指令不能为空']: 'コマンドは空であってはいけません',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}} は {{time}} にAIを開始しました',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}} は {{time}} にAIを閉じました。',
	['人机合作日总量']: '人間と機械の協力の総量',
	['人工通话总量']: '人工通話総量',
	['人机合作通话总量']: '人間機械協力通話総量',
	['以对话建立时间计算']: '対話による時間計算',
	['侦测到对话有异常状态 - 对话次数超过限制']: '会話に異常状態が検出されました - 会話回数が制限を超えました',
	['侦测到对话有异常状态 - 系统发生错误']: '会話に異常状態が検出されました - システムエラーが発生しました',
	['人机合作-人工日平均']: '人間と機械の協力 - 人工日平均',
	['人机合作-AI日平均']: '人間と機械の協力 - AI 日平均',
	['人机合作-人工平均通话时长']: '人間と機械の協力 - 人工平均通話時間',
	['人机合作-AI平均通话时长']: '人間と機械の協力 - AIの平均通話時間',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: '会話に異常が検出されました - AI APIの待機が2分を超えています',
	['侦测到对话有异常状态 - AI 发生错误']: '対話に異常状態を検出しました - AIでエラーが発生しました',
	['侦测到对话有异常状态 - AI 没有回复']: '対話に異常な状態が検出されました - AIが応答しません',
	['数据']: 'データ',
	['指令不能超过{{limit}}字']: '指示は{{limit}}字を超えてはいけません',
	['数据不能为空']: 'データは空であってはいけません。',
	['数据不能超过100万字']: 'データは100万文字を超えることはできません。',
	['需{{limit}}字以内']: '需{{limit}}字以内',
	['数据输入说明']: 'データ入力説明',
	['需100万字以内']: '100万字以内',
	['至少要有一组 ~~~~~ 与 =====']: '少なくとも 1 組の ~~~~~ と ===== が必要です',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: '区切り記号 ~~~~~ と ===== はペアで存在する必要があります',
	['需以 ===== 结尾']: '===== で終わる必要があります',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'タイトルの下の行にチルダを 5 個入力し、その前後に他の文字や空白を入れないでください',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: '内容の下の行に等号を 5 個入力し、その前後に他の文字や空白を入れないでください',
	['范例']: '例',
	['标题A（可多行）']: 'タイトルA（複数行可）',
	['内容A（可多行，可含任何文字）']: '内容A（複数行可、任意の文字を含められます）',
	['标题B（可多行）']: 'タイトルB（複数行可）',
	['内容B（可多行，可含任何文字）']: '内容B（複数行可、任意の文字を含められます）',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'モデル順序（上のモデルが優先して使用され、失敗時は自動的に下へ切り替わります）',
	['主要']: 'メイン',
	['备援{{index}}']: 'バックアップ{{index}}',
	['新增备援模型']: 'バックアップモデルを追加',
	['请输入数据']: 'データを入力してください',
	['正在转接中...']: '転送中...',
	['（中文）']: '（中国語）',
	['（英文）']: '（英語）',
	['（泰文）']: 'タイ語',
	['（越南文）']: '（ベトナム語）',
	['越南文名称']: 'ベトナム語の名称',
	['请输入越南文名称']: 'ベトナム語の名前を入力してください',
	['模式']: 'モード',
	['越南语']: 'ベトナム語',
	['IP白名单设定']: 'IPホワイトリスト設定',
	['建立时间']: '作成日時',
	['批次删除']: 'バッチ削除',
	['请确认是否删除 IP 白名单？']: 'IPホワイトリストを削除しますか？',
	['开启快捷选单']: 'クイックメニューを開く',
	['收合快捷选单']: 'クイックメニューを閉じる',
	['是否有收回人员讯息']: 'メンバーの情報を回収しましたか？',
	['是否有收回AI讯息']: 'AIメッセージを回収することは可能ですか？',
	['消息已被客服撤回']: 'メッセージはカスタマーサービスによって撤回されました',
	['用户快捷选单管理']: 'ユーザーショートカットメニュー管理',
	['电脑预览']: 'コンピュータープレビュー',
	['手机预览']: '携帯電話のプレビュー',
	['档案格式：PNG、JPG、JPEG']: 'ファイル形式：PNG、JPG、JPEG',
	['请选择上传档案']: 'ファイルをアップロードしてください',
	['新增快捷成功']: 'ショートカットの追加に成功しました',
	['修改快捷成功']: '変更クイック成功',
	['设定快捷选单成功']: 'ショートカットメニューの設定が成功しました',
	['删除快捷成功']: '削除ショートカット成功',
	['确定删除此快捷？']: 'このショートカットを削除してもよろしいですか？',
	['新增内容']: '新しい内容',
	['选项內容']: 'オプション内容',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}}の内容は空にできません',
	['请输入{{itemLabel}}标题']: '{{itemLabel}}のタイトルを入力してください',
	['请输入{{itemLabel}}选项']: '{{itemLabel}}のオプションを入力してください',
	['{{text}}不可为空']: '{{text}}は空にできません',
	['显示更多']: 'もっと見る',
	['公告标签']: '告知ラベル',
	['请选择公告标签']: 'お知らせのタグを選択してください',
	['{{text}}标题']: '{{text}}タイトル',
	['{{text}}內文']: '{{text}}内文',
	['{{text}}最多{{inputLimit}}个字']: '{{text}}は最大{{inputLimit}}字までです',
	['公告内文档案大小总计不得大于10MB']: '公告内文档案大小总计不得大于10MBと言うことは、10MBを超えてはいけません。',
	['用户尚未离开，确认要完成对话？']: 'ユーザーはまだ離脱していません。対話を終了してもよろしいですか？',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}} は {{time}} に会話を離れました。',
	['客服人员']: 'カスタマーサポート担当者',
	['*新增多个IP请使用逗号「 , 」隔开']: '複数のIPを追加するにはカンマ「,」で区切ってください',
	['是否新增IP白名单？']: 'IPホワイトリストを追加しますか？',
	['IP已存在']: 'IPはすでに存在します',
	['监控区管理']: '監視エリア管理',
	['监控区开关']: '監視エリアスイッチ',
	['设定监控区开关成功']: '監視エリアのスイッチ設定が成功しました',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: '機能を有効にすると、待機サービスエリアに「監視エリア」タブが追加され、全プラットフォームでAIに遮断された対話と未読時間が最も長い5つの対話が表示され、クリックすると該当する対話にすぐにジャンプできます。',
	['{{name}} 新增了标签 {{tag}}']: '{{name}} がタグ {{tag}} を追加しました。',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} はタグ {{tag}} を削除しました。',
	['状态切换为暂离']: '状態が一時的に離れます',
	['状态切换为工作中']: '状態を作業中に切り替え',
	['监控区']: '監視エリア',
	['自动接线管理']: '自動接続管理',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'カスタマーサービスの全プラットフォームの対応数が上限に達した後、システムは自動的に待機サービスエリアの対話を接続しません。カスタマーサービス担当者による手動接続の数は制限されません。',
	['自动接线数量上限']: '自動接続数上限',
	['设定自动接线成功']: '自動接続の設定が成功しました',
	['{{name}} 进线']: '{{name}} 着信',
	['工作/暂离时间']: '勤務/休暇時間',
	['工作时长报表']: '勤務時間報告',
	['暂离时长报表']: '一時離脱時間レポート',
	['平均工作时长']: '平均労働時間',
	['平均暂离时长']: '平均離脱時間',
	['关键字提醒']: 'キーワードリマインダー',
	['客户发话']: '顧客が話す',
	['AI发话']: 'AIの発言',
	['发话来源']: '発話源',
	['请输入发话来源、关键字']: '発話元、キーワードを入力してください',
	['新增关键字']: '新しいキーワード',
	['修改关键字']: 'キーワードを修正する',
	['新增关键字成功']: 'キーワードの追加に成功しました',
	['修改关键字成功']: 'キーワードの変更が成功しました',
	['删除关键字成功']: 'キーワードの削除に成功しました',
	['是否删除此关键字？']: 'このキーワードを削除しますか？',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: '「キーワードは100文字以内で「；」で区切ってください。」',
	['客户触发关键字 [{{word}}] 请客服人员注意']: '顧客がキーワード [{{word}}] をトリガーしました。カスタマーサービス担当者は注意してください。',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AIトリガーキーワード [{{word}}] カスタマーサービス担当者にご注意ください',
	['请输入通知时间']: '通知時間を入力してください',
	['自动接线开关']: '自動接続スイッチ',
	['自动接线数量上限不可为空']: '自動接続数上限は空にできません',
	['请输入数量上限']: '数量上限を入力してください',
	['离开状态侦测开关']: '状態検出スイッチを離れる',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: '開始後、カスタマーサポートスタッフがプラットフォームの最後の作業状態であるか、まだ対応中で他の人との会話に協力していない場合、離席状態に切り替えることはできません。',
	['离开时间通知开关']: '出発時刻通知スイッチ',
	['通知时间不可重复']: '通知時間は重複できません',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: '検知権限CSアカウントの退席時間、退席時間が設定時間に達した際に権限マネージャー以上のアカウントおよび退席時間を引き起こしたCSアカウント本人に通知します。',
	['最后暂离时间报表']: '最終離脱時間報告',
	['平均最后暂离时间']: '平均最後離脱時間',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} の離脱時間は [{{minute}}] 分間になりました！',
	['历史对话记录下载']: '履歴対話記録ダウンロード',
	['使用模式']: '使用モード',
	['标准模式']: '標準モード',
	['ID模式']: 'IDモード',
	['即进模式']: '即進モード',
	['复制即进网址']: 'コピーして進むURL',
	['生成新网址']: '新しいURLを生成する',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: '顧客プロフィール資料を提供する標準モードであり、このモードはシステムのプリセットモードです。',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'IDを入力してカスタマーサービスに入ることができ、顧客のプロフィール情報は提供しなくても構いません。',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'ウェブサイトに直接アクセスすることでカスタマーサポートシステムに入ることができ、情報を提供する必要はなく、システムが自動的にランダムな訪問者名を与えます。',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: '[<<prevTypeText>>] から [<<nextTypeText>>] に切り替えるか再確認してください。',
	['以下是即进网址']: '以下は即進ウェブサイトです。',
	['复制网址']: 'コピーしたURL',
	['使用模式切换成功']: '使用モード切替成功',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'ウェブサイトの変更を再確認してください。一度変更されると<<redText>>',
	['当前即进网址']: '現在のアクセスURL',
	['新即进网址']: '新しいアドレス',
	['复制即进网址成功']: 'コピーしてウェブサイトに進むことが成功しました',
	['报表统计']: '報告統計',
	['操作時間']: '操作時間',
	['统计类型']: '統計タイプ',
	['请选择统计类型']: '統計タイプを選択してください',
	['查询参数']: 'クエリパラメータ',
	['申请时间']: '申請時間',
	['产出时间']: '産出時間',
	['申请帐号']: 'アカウントを申請する',
	['详细资料']: '詳細情報',
	['重新执行统计']: '再度統計',
	['执行统计']: '統計を実行する',
	['登入时间范围']: 'ログイン時間範囲',
	['选择团队：筛选出该团队所有客服人员']: 'チームを選択：そのチームのすべてのカスタマーサービススタッフをフィルタリングする',
	['API接收日志']: 'API受信ログ',
	['新增来源']: '新しいソース',
	['CS']: 'CS',
	['包网']: '包網：パッケージネット',
	['包网API']: '包網API',
	['第 {{min}} - {{max}} 笔']: '第 {{min}} - {{max}} 件',
	['选择的日期区间需小于等于{{limit}}天']: '選択した日付範囲は{{limit}}日以内である必要があります。',
	['请选择日期时间查询条件']: '日時の検索条件を選択してください',
	['类型']: 'タイプ',
	['公司']: '会社',
	['请输入公司']: '会社を入力してください',
	['会员帐号']: '会員アカウント',
	['请输入会员帐号']: '会員アカウントを入力してください',
	['是否查看详细资料？']: '詳細情報を確認しますか？',
	['传送资料']: 'データを送信する',
	['CS回覆资料']: 'CS返信資料',
	['内容']: '内容',
	['请选择进入的公司']: '入る会社を選択してください',
	['指令数据更新纪录']: '指令データ更新記録',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1.ソート機構：全ての会社の指示は統一的にソートされ、システムの効率的な運用が保証されます。',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: 'データ隔離：ユーザーは自社の更新記録のみを閲覧でき、他社の記録は閲覧できません。',
	['微调训练']: '微調訓練',
	['执行微调']: '微調を実行する',
	['操作帐号']: '操作アカウント',
	['是否修改AI API?']: 'AI APIを変更しますか？',
	['保存设置']: '設定を保存',
	['修改AI API成功']: 'AI APIの修正に成功しました。',
	['请输入{{text}}']: '{{text}}を入力してください',
	['{{text}}不能超过{{limit}}字元']: '{{text}}は{{limit}}文字を超えることはできません',
	['AI API']: 'AI API',
	['微调训练记录']: '微調トレーニング記録',
	['模型名称']: 'モデル名',
	['新增文本']: '新しいテキスト',
	['修改文本']: 'テキストを修正する',
	['请输入名称']: '名前を入力してください',
	['取消修改微调文本']: 'テキストの微調整をキャンセル',
	['角色不可为空']: '役割は空にできません',
	['请选择角色']: 'キャラクターを選んでください',
	['内容不可为空']: '内容は空にできません',
	['请输入内容']: '内容を入力してください',
	['系统']: 'システム',
	['会员']: '会員',
	['AI']: 'AI',
	['请确认是否取消？']: 'キャンセルしてもよろしいですか？',
	['新增微调文本成功']: '新しいファインチューニングテキストが成功しました',
	['修改微调文本成功']: 'テキストの微調整が成功しました',
	['自定模型名称']: 'カスタムモデル名',
	['微调确认讯息']: '微調確認メッセージ',
	['请确认是否执行微调训练？']: '微調トレーニングを実行するか確認してくださいか？',
	['删除微调文本']: '微調テキストを削除',
	['请确认是否刪除？']: '削除しますか？',
	['刪除微调文本成功']: '微調テキストの削除に成功しました',
	['请输入模型名称']: 'モデル名を入力してください',
	['执行微调成功']: 'ファインチューニングが成功しました。',
	['取消修改文本成功']: 'テキストの変更が成功しました',
	['取消新增文本成功']: 'テキストの追加が成功裏にキャンセルされました',
	['您已成功登出客服系统。']: 'カスタマーサポートシステムから正常にログアウトしました。',
	['如需重新登录，请返回包网！']: '再ログインするには、パッケージネットに戻ってください！',
	['您已成功登出客服系统管理端。']: 'お客様サポートシステム管理端から正常にログアウトしました。',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: '「平均待機時間」が 0 秒と表示される場合、考えられる原因は次のとおりです：',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '1.当日のすべての会話の待機時間は0秒です（例えば、自動応答や即時応答により、待つ必要がありません）。',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2.公式「毎日の総待機時間 ÷ 毎日の対話数」に基づいて、計算結果は四捨五入して0秒です。',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'システムが「未ログイン」と表示する場合、そのアカウントは設定されたチーム時間内に対話データを一切生成していないことを意味します。',
	['加入微调']: '微調を追加',
	['启用API Key']: 'APIキーを有効にする',
	['微调汇入对话记录']: '微調のインポート対話記録',
	['对话数量']: '対話数',
	['文本最后角色需为AI或客服人员']: 'テキストの最後のキャラクターはAIまたはカスタマーサポート担当者である必要があります。',
	['汇入微调文本']: '微調テキスト',
	['檔案格式：CSV，且档案大小不得大于']: 'ファイル形式：CSVで、ファイルサイズはそれ以上であってはいけません。',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'テキストの最後のキャラクターはAIまたはカスタマーサポートのスタッフでなければなりません。修正してからエクスポートするか、微調整を行ってください。',
	['批量加入微调']: 'バッチ追加微調',
	['自定加入微调的名称']: '微調の名前を追加する',
	['微调名称']: '微調名',
	['请输入微调的名称']: '微調の名前を入力してください',
	['微调的名称']: '微調の名前',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: '一括削除を確認してください（合計 {{selectedFineTuningRecordsLength}} 件）',
	['已取消']: 'キャンセルされました',
	['取消微调']: '微調のキャンセル',
	['取消微调成功']: '微調のキャンセルが成功しました',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'このカスタマーサービスシステムの微調整トレーニングをキャンセルする際には、対応するOpenAIバックエンドの微調整トレーニングも同時にキャンセルする必要があります。両方がキャンセルされて初めて、微調整トレーニングが完全に削除されます。このカスタマーサービスシステムの微調整トレーニングをキャンセルしてもよろしいですか？',
	['复制快捷语成功']: 'コピーショートカットが成功しました',
	['复制常用图片成功']: 'よく使う画像のコピーに成功しました',
	['左侧']: '左側',
	['右侧']: '右側',
	['{{text}}正在服务{{total}}则对话']: '{{text}}が{{total}}件の会話をサービス中です',
	['新增跑马灯成功']: '新しいマーキーが正常に追加されました',
	['修改跑马灯成功']: 'マルチスクロールの修正が成功しました',
	['刪除跑马灯成功']: 'ランナーの削除に成功しました',
	['启用跑马灯成功']: 'マラソンライトの有効化に成功しました',
	['停用跑马灯成功']: 'ウィンドウズ・マーカーの停止に成功しました',
	['对象栏位']: '対象フィールド',
	['显示跑马灯内容']: 'ランダムな内容を表示する',
	['请确认是否启用跑马灯？']: 'ランナーライトを有効にするか確認してくださいか？',
	['请确认是否停用跑马灯？']: 'ランプダンスを無効にするか確認してくださいか？',
	['请确认是否删除跑马灯？']: 'マラソンランナーを削除してもよろしいですか？',
	['{{text}}最多{{inputLimit}}组']: '{{text}}は最大で{{inputLimit}}グループです',
	['数值范围']: '数値範囲',
	['数值不能为空']: '数値は空にできません',
	['数值']: '数値',
	['请输入数字']: '数字を入力してください',
	['输入多组文字请用, 区隔']: '複数のテキストを入力する場合は、, で区切ってください。',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'ユーザーが対象の設定名称および欄位ルールに合致する内容である場合のみ、ランニングバナーのプロモーションが有効になります。',
	['新增跑马灯']: '新しいマリキュレーター',
	['对象栏位不能为空']: 'オブジェクトフィールドは空にできません',
	['请输入对象栏位']: 'オブジェクト欄を入力してください',
	['栏位规则']: 'カラムルール',
	['栏位规则不能为空']: '項目ルールは空であってはいけません',
	['请选择栏位规则']: '列の選択ルール',
	['开头图示']: '冒頭図示',
	['开头图示不能为空']: '開始の図示は空白にできません',
	['请选择开头图示']: '始めの図を選択してください',
	['跑马灯内容']: 'マラソンライトの内容',
	['修改跑马灯']: 'マラソン表示を修正',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'プラットフォーム設定の変更は下位のキャラクターに同期適用されますが、変更を確認しますか？',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: '「[個人/公共]によく使う画像[{{title}}]を削除してもよろしいですか？」',
	['一经确认删除无法复原。']: '確認されると削除は復元できません。',
	['客服日志']: 'カスタマーサポートログ',
	['请输入内容等关键字']: '入力内容などのキーワード',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: '[個人/公共]ショートカット語[{{title}}]：[{{content}}]を削除してもよろしいですか？',
	['没有其他进入标签被开启，故无法关闭此进入标签']: '他の入室タグが開いていないため、この入室タグを閉じることができません。',
	['没有其他进入标签被开启，故无法删除此标签']: '他の入るタグが開かれていないため、このタグを削除することはできません。',
	['所有人']: '全員',
	['自定义对象']: 'カスタムオブジェクト',
	['套用对象']: '適用対象',
	['回主画面']: 'メイン画面に戻る',
	['孟加拉语']: 'ベンガル語',
	['繁体中文']: '繁体字',
	['简体中文']: '簡体字',
	['韩语']: '韓国語',
	['日语']: '日本語',
	['葡萄牙语']: 'ポルトガル語',
	['印地语']: 'ヒンディー語',
	['俄语']: 'ロシア語',
	['重要资讯']: '重要な情報',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: '会話中に言語を切り替えると、場合によってはメッセージ翻訳機能が約10分遅れることがあり、新しいメッセージと古いメッセージの読み取りに影響を与えることがあります。言語を切り替えますか？',
	['暂无对话']: '対話なし',
	['档案上传中']: 'ファイルアップロード中',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} は {{time}} に自動通知を開始しました',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} は {{time}} に自動プッシュ通知を閉じました',
	['商户代码']: 'マーチャントコード',
	['请输入商户代码']: 'マーチャントコードを入力してください',
	['密钥']: 'シークレットキー',
	['请输入密钥']: 'シークレットキーを入力してください',
	['共同设定']: '共通設定',
	['充值未到帐设定']: '入金未着設定',
	['出款未到帐设定']: '出金未着設定',
	['确认进行储存？']: '保存を確認しますか？',
	['SKILL开关']: 'SKILLスイッチ',
	['请输入SKILL']: 'SKILLを入力してください',
	['派单 API 参数']: '派遣APIパラメータ',
	['请输入派单API URL']: '派遣API URLを入力してください',
	['开单者username']: '発注者ユーザー名',
	['请输入开单者username']: '発注者ユーザー名を入力してください',
	['频道名称']: 'チャンネル名',
	['请输入频道名称']: 'チャンネル名を入力してください',
	['开单原因']: '発注理由',
	['请输入开单原因']: '発注理由を入力してください',
	['充值订单查询 API URL']: '入金注文照会 API URL',
	['出款订单查询 API URL']: '出金注文照会 API URL',
	['同义词设定']: '同義語設定',
	['开启BM25']: 'BM25を開始する',
	['同义词']: '同義語',
	['更新时间']: '更新時間',
	['批次新增同义词']: 'バッチで同義語を追加',
	['修改同义词']: '修正同義語',
	['新增同义词']: '同義語を追加',
	['请输入同义词，使用逗号区隔不同词汇']: '同義語を入力してください、異なる単語をカンマで区切ってください',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: '以下の内容は「日本語」ではどう言いますか？  \n直接翻訳結果を返してください。単語の翻訳は単語だけで、複数の結果がある場合は最初のものを使用してください。  \n---\n> 異なる語彙はカンマで区切り、同義語の異なるグループはセミコロンで区切ってください。',
	['输入格式说明：']: '入力形式の説明：',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: '充填,チャージ,入金,課金',
	['词汇与标点符号前后不要出现空白']: '語彙と句読点の前後に空白を挿入しないでください。',
	['请用；或分行(enter)区隔同组同义词，例如：']: '同義語；同じ意味の言葉',
	['充值,储值,入金,课金']: 'チャージ',
	['log in,登入;亲,宝贝']: 'ログイン、ログイン; 親、宝物',
	['请输入同义词']: '同義語を入力してください',
	['同义词不可为空']: '同義語は空にできません',
	['同义词格式有误']: '同義語の形式が間違っています',
	['同义词不可有特殊字元']: '同義語には特殊文字を含めてはいけません',
	['字元不可超过10000']: '文字数は10000を超えてはいけません。',
	['需至少输入两个词汇']: '少なくとも二つの単語を入力する必要があります。',
	['删除同义词']: '同義語を削除',
	['请确认是否删除同义词？']: '同義語を削除しますか？',
	['新增同义词成功']: '同義語の追加が成功しました',
	['新增同义词失败']: '同義語の追加に失敗しました',
	['修改同义词成功']: '同義語の修正が成功しました',
	['修改同义词失败']: '同義語の変更に失敗しました',
	['删除同义词成功']: '同義語の削除に成功しました',
	['删除同义词失败']: '削除の同義語の削除に失敗しました',
	['内容有重复字']: '内容が重複している',
	['新增图片，详细图片请参考公告管理']: '画像を追加しました。詳細な画像は公告管理を参照してください。',
	['目前只支援ChatGPT进行微调训练']: '現在はChatGPTだけが微調整トレーニングをサポートしています。',
	['AI系列']: 'AIシリーズ',
	['AI系列不能为空']: 'AIシリーズは空であってはいけません',
	['启用ChatGPT']: 'ChatGPTを有効にする',
	['启用Gemini']: 'Geminiを有効にする',
	['AI客服']: 'AIカスタマーサービス',
	['ID入口']: 'IDエントリー',
	['IP']: 'IP',
	['USER ID']: 'ユーザーID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}}の内容は空にできません',
	['{{text}}仅能输入数字']: '{{text}}は数字のみ入力できます',
	['{{text}}最多{{limit}}个字元']: '{{text}}は最大{{limit}}文字までです。',
	['{{text}}最多數字{{limit}}碼']: '{{text}}は最大{{limit}}桁の数字です。',
	['{{time}}分']: '{{time}}分',
	['{{time}}时']: '{{time}}時',
	['{{time}}秒']: '{{time}}秒',
	['上一则发送后等待时间']: '前回の送信後の待機時間',
	['上传图片']: '画像をアップロード',
	['主要API keys']: '主要APIキー',
	['主要语言']: '主要言語',
	['事件']: 'イベント',
	['以查看预览效果']: 'プレビュー効果を確認するために',
	['依照选择模组设定UI显示位置及功能。']: '選択モジュールに基づいてUIの表示位置と機能を設定します。',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: '選択したスタイルに応じて配色を調整する（背景、ボックス、配色、線の感覚を含む）。',
	['修改帐号履历成功']: 'アカウントの履歴が成功裏に修正されました',
	['修改翻译API成功']: '翻訳APIの修正が成功しました',
	['充值帐号']: 'アカウントのチャージ',
	['共 {{numOfItems}} 笔']: '共 {{numOfItems}} 件',
	['关 闭']: '閉じる',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: '閉じると、全体のプッシュ通知システムが停止し、すべてのプッシュメッセージが一時的に無効になります。いつでも再度開くことができます。',
	['内容最多20字元']: '内容は最大20文字です。',
	['内容预览']: '内容プレビュー',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: '切り替え後、ランプ文字とショートカットキーは表示が不明瞭またはコントラストが不足することがありますので、バックエンドで再設定する必要があります。',
	['删除履历']: '履歴を削除',
	['删除帐号履历成功']: 'アカウント履歴の削除が成功しました。',
	['删除跑马灯']: 'ランナーを削除',
	['加载中...']: '読み込み中...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'チェックを入れると、そのアカウントがカスタマーサービスに連絡する際に、アカウント名の横に表示されます。',
	['即时预览']: '即時プレビュー',
	['取消新增微调文本']: '新しい微調整テキストの追加をキャンセル',
	['古典深色风格']: 'クラシックダークスタイル',
	['單次']: '単発',
	['回传表单']: 'フォームを返す',
	['外观风格']: '外観スタイル',
	['客户端视觉设定']: 'クライアントビジュアル設定',
	['客户端视觉设定成功']: 'クライアントビジュアル設定成功',
	['尚无资料']: 'データはまだありません',
	['展开']: '展開',
	['履历数量']: '履歴数量',
	['帐号履历']: 'アカウント履歴',
	['帐号履历管理']: 'アカウント履歴管理',
	['平台代码不能有空白']: 'プラットフォームコードには空白を含めてはいけません。',
	['平台代码仅能输入英文和数字']: 'プラットフォームコードには英語と数字のみを入力できます。',
	['平台代码最多5码']: 'プラットフォームコードは最大5桁です',
	['平台代码最少2码']: 'プラットフォームコードは最低2桁です',
	['平台语言']: 'プラットフォーム言語',
	['平均首次工作时间']: '平均初回勤務時間',
	['建立者']: '創設者',
	['开关']: 'スイッチ',
	['快速通道']: 'ファストトラック',
	['手动推播']: '手動プッシュ',
	['手机版']: 'モバイル版',
	['批量删除']: '一括削除',
	['排序']: 'ソート',
	['推播功能']: 'プッシュ通知',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'プッシュ機能 OFF：プッシュ機能がオフになると、システム全体が機能しなくなり、リスト内のすべての戦略が無効になります。',
	['推播时间']: 'プッシュ通知の時間',
	['推播讯息列表']: 'プッシュ通知リスト',
	['推播设定']: 'プッシュ通知設定',
	['操作内容']: '操作内容',
	['收起']: '折りたたむ',
	['数值/内容']: '数値/内容',
	['数值/内容不可为空']: '数値/内容は空にできません',
	['数值只能输入数字、负号、小数点']: '数値は数字、マイナス記号、小数点のみ入力できます。',
	['数值小数最多6位数']: '数値小数は最大で6桁です',
	['数值整数最多15位']: '数値整数は最大15桁です。',
	['新增履历']: '履歴の追加',
	['新增帐号履历成功']: 'アカウント履歴の追加に成功しました',
	['新增类型']: '新しいタイプ',
	['无工作']: '無職',
	['时间设定需至少为 3 分钟']: '時間設定は少なくとも3分でなければなりません。',
	['是否修改翻译API?']: '翻訳APIを変更しますか？',
	['更新成功']: '更新成功',
	['更新者']: '更新者',
	['架构模组']: 'アーキテクチャモジュール',
	['栏位名称']: '欄位名',
	['栏位类型']: 'カラムタイプ',
	['栏位类型不可为空']: '列のタイプは空にできません',
	['档案格式不符']: 'ファイル形式が一致しません',
	['PDF文件']: 'PDFファイル',
	['模式与间隔时间']: 'モードと間隔時間',
	['欢迎回来']: 'お帰りなさい',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'この操作は他の言語を自動的に翻訳し、元の入力内容が翻訳結果に置き換えられます。続行してもよろしいですか？',
	['汇入']: 'インポート',
	['汇入微调文本成功']: 'テキストのインポートが成功しました',
	['汇出微调文本成功']: '微調テキストのエクスポートに成功しました。',
	['清空翻译']: '翻訳をクリアする',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'すべての言語の内容を入力完了後に確定できます。自動翻訳で残りの言語を補完できます。',
	['标题与内容皆需填写才可自动翻译']: 'タイトルと内容の両方を入力すると自動翻訳できます。',
	['状态持续时间']: '状態の持続時間',
	['用户帐号']: 'ユーザーアカウント',
	['用户帐号不能为空']: 'ユーザーアカウントは空であってはいけません',
	['电脑版']: 'デスクトップ版',
	['目前无适用推播']: '現在適用のプッシュ通知はありません。',
	['目前有启用中的侦测语言平台，无法关闭']: '現在稼働中の言語検出プラットフォームは、停止できません。',
	['确定删除IP白名单？']: 'IPホワイトリストを削除してもよろしいですか？',
	['确定发送推播？']: 'プッシュ通知を送信しますか？',
	['确定要关闭推播功能吗？']: '推播機能を閉じますか？',
	['确认删除此笔履历?']: 'この履歴を削除してもよろしいですか？',
	['确认要删除推播讯息？']: 'プッシュ通知を削除してもよろしいですか？',
	['立即登入']: '今すぐログイン',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: '第 {{min}} - {{max}} 件/共 {{numOfItems}} 件',
	['筛选条件']: '絞り込み条件',
	['类型名称']: 'タイプ名',
	['系统预设模组']: 'システムプリセットモジュール',
	['经典浅色风格']: 'クラシックライトスタイル',
	['翻译API']: '翻訳API',
	['聊天介面']: 'チャットインターフェース',
	['自动推播']: '自動プッシュ',
	['自动推播功能']: '自動プッシュ機能',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: '自動プッシュ機能 OFF：リスト内のすべてのプッシュメッセージはカスタマーサービスによって手動で実行可能ですが、すべてのタイマー機能は停止します。',
	['自定义']: 'カスタマイズ',
	['自定义文案']: 'カスタム文案',
	['自客服接起对话后开始计算']: '自カスタマーサービスが会話を始めた後、計算を開始します。',
	['该类型目前有推播讯息套用中，无法删除']: '現在このタイプはプッシュ通知が適用されているため、削除できません。',
	['详细说明']: '詳細説明',
	['请先选择推播类型']: 'プッシュ通知のタイプを選択してください。',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: '一括削除を確認してください（合計 {{selectedFineTuningRecordsLength}} 件）。',
	['请输入事件']: 'イベントを入力してください',
	['请输入会员ID']: '会員IDを入力してください',
	['请输入內容']: '内容を入力してください',
	['请输入关键字']: 'キーワードを入力してください',
	['请输入您的会员 ID 以继续']: '会員 ID を入力してください。',
	['请输入数值/内容']: '数値/内容を入力してください',
	['请输入文字']: '文字を入力してください',
	['请输入栏位名称']: 'フィールド名を入力してください',
	['请输入用户帐号']: 'ユーザーアカウントを入力してください',
	['请输入类型名称']: 'タイプ名を入力してください',
	['请输入详细说明']: '詳細な説明を入力してください',
	['请选择上方下拉选单']: '上のドロップダウンメニューを選択してください',
	['请选择主要语言自动翻译']: '主要な言語を選択して自動翻訳してください',
	['请选择帐号状态']: 'アカウントの状態を選択してください',
	['请选择平台']: 'プラットフォームを選択してください',
	['请选择推播项目']: 'プッシュ項目を選択してください',
	['请选择栏位类型']: '欄位タイプを選択してください',
	['请选择类型']: 'タイプを選択してください',
	['请选择类型与项目(标题)以预览内容']: 'タイプと項目（タイトル）を選択して内容をプレビューしてください',
	['请选择表单选项']: 'フォームのオプションを選択してください',
	['请选择运算规则']: '運算規則を選択してください',
	['请选择预览画面']: 'プレビュー画面を選択してください',
	['跑马灯设定']: 'マラソン灯設定',
	['轮播']: 'カルーセル',
	['轮播模式']: 'カルーセルモード',
	['轮播间隔时间']: 'スライドの間隔時間',
	['运算规则']: '運算ルール',
	['运算规则不可为空']: '演算ルールは空であってはいけません',
	['返回上一层']: '前のレイヤーに戻る',
	['返回上一页']: '前のページに戻る',
	['送出推播']: 'プッシュ通知を送信',
	['选单介面']: 'メニューインターフェース',
	['选择推播类型']: 'プッシュ通知の種類を選択',
	['选择推播项目(标题)']: 'プッシュ通知項目（タイトル）',
	['通知时间']: '通知時間',
	['通知时间不能为空']: '通知時間は空にできません',
	['重新产生Key/IV']: 'キー/IVを再生成する',
	['重要客户']: '重要顧客',
	['需为1~60正整数']: '1~60の正の整数である必要があります',
	['预估时间']: '予想時間',
	['预览图片']: '画像のプレビュー',
	['首次工作时间报表']: '初回勤務時間報告',
	['日志管理']: 'ログ管理',
	['API传送日志']: 'API送信ログ',
	['订单号']: '注文番号',
	['三方单号']: 'サードパーティ注文番号',
	['请输入订单号']: '注文番号を入力してください',
	['请输入三方单号']: 'サードパーティ注文番号を入力してください',
	['充值订单查询']: 'チャージ注文照会',
	['出款订单查询']: '出金注文照会',
	['开派单']: '配送注文作成',
	['传送派单信息']: '配送情報送信',
	['CS传送资料']: 'CS送信データ',
	['平台回覆资料']: 'プラットフォーム返信データ',
	['{{text}}需以{{prefix}}开头']: '{{-text}}は{{-prefix}}で始まる必要があります',
	['系统通知']: 'システム通知',
	['派单传送讯息']: '配送メッセージ送信',
	['派单传送档案']: '配送ファイル送信',
	['请输入平台']: 'プラットフォームを入力してください',
	['派单讯息润饰设定']: '配送メッセージ整形設定',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'この指示は「AI共同設定」と「プラットフォームAI設定」を読み込まず、独立したAgentとして使用します',
	['用户个人设定']: 'ユーザー個人設定',
	['新增用户个人资讯']: 'ユーザー個人情報の追加',
	['个人资讯参数名称']: '個人情報パラメータ名',
	['请输入个人资讯参数名称']: '個人情報パラメータ名を入力してください',
	['*新增多个请使用逗号「 , 」隔开']: '*複数追加する場合はカンマ「 , 」で区切ってください',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'このプラットフォームのどの個人情報をAIに渡すかを設定します。「ユーザー個人設定」に設定されたパラメータのみがAIに送信されます',
	['批次删除用户个人资讯']: 'ユーザー個人情報の一括削除',
	['确定要批次删除用户个人资讯吗？']: 'ユーザー個人情報を一括削除してもよろしいですか？',
	['个人资讯参数名称不能为空']: '個人情報パラメータ名は空にできません',
	['已存在「{{name}}」']: '「{{-name}}」はすでに存在します',
	['最多可新增{{limit}}个，已超过上限']: '最大{{-limit}}個まで追加できます。上限を超えました',
	['新增用户个人资讯成功']: 'ユーザー個人情報の追加に成功しました',
	['新增用户个人资讯失败']: 'ユーザー個人情報の追加に失敗しました',
	['删除用户个人资讯成功']: 'ユーザー個人情報の削除に成功しました',
	['删除用户个人资讯失败']: 'ユーザー個人情報の削除に失敗しました',
	['图像管理']: '画像管理',
	['自定义图像']: 'カスタム画像',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'ファイル形式：「PNG、JPG」ファイルサイズは500KBを超えてはいけません',
	['档案最大500K']: 'ファイル最大500K',
	['新增图像成功']: '画像の追加に成功しました',
	['删除图像成功']: '画像の削除に成功しました',
	['是否确定删除图像？']: '画像を削除してもよろしいですか？',
	['内容设定']: '内容設定',
	['英语']: '英語',
	['{{language}}内容']: '{{language}}内容',
	['请输入{{language}}内容']: '{{language}}内容を入力してください',
	['请选择时间']: '時間を選択してください',
	['请选择公司']: '会社を選択してください',
	['请输入{{label}}']: '{{label}}を入力してください',
	['原文参考（{{language}}）']: '参照元（{{language}}）',
	['确定清空设定吗？']: '設定をクリアしてもよろしいですか？',
	['确定取消设定吗？']: '設定をキャンセルしてもよろしいですか？',
	['{{language}}{{tab}}']: '{{language}}{{tab}}',
	['未完成']: '未完了',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}}の{{label}}が{{limit}}文字を超えています',
	['公告标题']: 'お知らせのタイトル',
	['进线IP']: '接続元IP',
	['请输入进线IP']: '接続元IPを入力してください',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'モデル切替：{{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'BWバックエンドでアカウントを削除すると、カスタマーサービスシステムのアカウントも同期して削除されます',
	['系统已有新版本，请重新整理']: '新しいバージョンがあります。再度リフレッシュしてください。',
	['页面加载失败，请重试']: 'ページの読み込みに失敗しました。再試行してください。',
	['翻译中']: '翻訳中',
	['监控与即时摘要设定']: 'モニタリング＆即時要約設定',
	['批量转接']: '一括転送',
	['已选 {{count}} 则对话']: '{{count}} 件の会話を選択',
	['勾选']: '選択',
	['全平台服务人数']: '全プラットフォームのサービス人数',
	['未开启{{platform}}平台']: '{{-platform}}プラットフォームが有効になっていません',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '{{-inviter}} から {{-invitee}} への転送に成功しました。全 {{count}} 件。',
	['接受']: '受け入れる',
	['拒绝({{seconds}}S)']: '拒否({{seconds}}S)',
	['生成链接']: 'リンクを生成',
	['链接生成中...']: 'リンク生成中...',
	['复制链接']: 'リンクをコピー',
	['已复制链接']: 'リンクをコピーしました',
	['档案上传失败']: 'ファイルのアップロードに失敗しました',
	['转档失败，请重新上传']: '変換に失敗しました。もう一度アップロードしてください',
	['人工回复']: '手動返信',
	['检视回复']: '返信を確認',
	['{{time}} AI 拦截对话']: '{{time}} AI が会話を遮断',
	['AI 拦截原因与人工回复']: 'AI 遮断理由と手動返信',
	['人工回复失败']: '手動返信に失敗しました',
	['回复讯息']: '返信メッセージ',
	['对话摘要']: '会話の要約',
	['建议回复']: '推奨返信',
	['拦截原因']: '遮断理由',
	['拦截回复']: '遮断された返信',
	['确定送出']: '送信する',
	['生成链接失败']: 'リンクの生成に失敗しました',
	['连接超时，请稍后再试']: '接続がタイムアウトしました。しばらくしてから再試行してください',
	['上一则']: '前へ',
	['下一则']: '次へ',
	['重新传送']: '再送信',
	['传送中...']: '送信中...',
	['用户端翻译失败']: 'ユーザー側への翻訳に失敗しました',
	['重新传送失败']: '再送信に失敗しました',
	['请确认是否删除以下模型？']: '以下のモデルを削除してもよろしいですか？',
	['新增模型']: 'モデルを追加',
	['请选择AI系列']: 'AIシリーズを選択してください',
	['支援模型']: '対応モデル',
	['支援模型不能为空']: '対応モデルは必須です',
	['请选择支援模型']: '対応モデルを選択してください',
	['AI模型管理']: 'AIモデル管理',
	['模型不能为空']: 'モデルは必須です',
	['请选择模型']: 'モデルを選択してください',

	['对话类型']: '対話タイプ',
	['单纯AI讯息']: 'AIメッセージのみ',
	['单纯人员讯息']: '担当者メッセージのみ',
	['人员+AI讯息']: '担当者＋AIメッセージ',
	['是否经过AI拦截']: 'AIによる遮断があったか',
	['是否修改AI拦截建议回覆']: 'AI遮断の提案返信を修正したか',
	['监控API keys']: '監視APIキー',
	['管理']: '管理',

	['启用显性快取']: '明示的キャッシュを有効化',
	['AI监控拦截总量']: 'AI監視遮断の総量',
	['AI监控拦截']: 'AI監視遮断',
	['有修改建议回覆总量']: '推奨返信の修正あり',
	['触发关键字：{{keywords}}。']: 'トリガーされたキーワード：{{-keywords}}。',

	['版面已套用，但尚未同步至帐号']: 'レイアウトを適用しましたが、アカウントにはまだ同期されていません',
	['服务器重设失败，下次开启工作区时会再同步']: 'サーバーでのリセットに失敗しました。次回ワークスペースを開いたときに再同期されます',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'ブラウザーがレイアウトを保存できません。離れる前にアカウントへの同期完了をご確認ください',

	['重设版面配置']: 'レイアウトをリセット',
	['确定要将版面配置回复为系统预设吗？']: 'レイアウトをシステム既定に戻しますか？',
	['客服支援语言']: 'カスタマーサポート対応言語',
	['请选择支援语言']: '対応言語を選択してください',
	['请选择客服支援语言']: 'カスタマーサポート対応言語を選択してください',

	['删除平台']: 'プラットフォームを削除',
	['是否确定删除{{code}}平台']: 'プラットフォーム{{-code}}を削除しますか？',
	['删除{{code}}平台成功']: 'プラットフォーム{{-code}}を削除しました',
	['上传图片或PDF']: '画像またはPDFをアップロード',
	['当前平台维护中，如有疑问请联系管理员']: '現在のプラットフォームはメンテナンス中です。ご不明な点は管理者にお問い合わせください。',
	['当前平台已禁用，如有疑问请联系管理员']: '現在のプラットフォームは無効化されています。ご不明な点は管理者にお問い合わせください。',
	['收回提示文字']: '取り消し時の表示テキスト',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'ヒントを入力してください。例：申し訳ございません。誤送信のため訂正させていただきます。',
	['标签名称']: 'タグ名',
	['预览失败']: 'プレビューに失敗しました',
	['放大']: '拡大',
	['缩小']: '縮小',
	['上一页']: '前のページ',
	['下一页']: '次のページ',
	['点击预览']: 'クリックしてプレビュー',
};
